import {
  SharingDraftBendingTextConfiguration,
  SharingDraftConfiguration,
  SharingDraftConfigurationWithText,
  SharingDraftDesignConfiguration,
  SharingDraftFilterSettings,
  SharingDraftFilterSettingsById,
  SharingDraftPlaceholderTextConfiguration,
  SharingDraftSpecialTextConfiguration,
  SharingDraftTextConfiguration,
} from '@/types';

export const isSharingDraftDesignConfiguration = (
  configuration: SharingDraftConfiguration
): configuration is SharingDraftDesignConfiguration => configuration?.type === 'design';

export const isSharingDraftTextConfiguration = (
  configuration: SharingDraftConfiguration
): configuration is SharingDraftTextConfiguration => configuration?.type === 'text';

export const isSharingDraftPlaceholderTextConfiguration = (
  configuration: SharingDraftConfiguration
): configuration is SharingDraftPlaceholderTextConfiguration =>
  configuration?.type === 'placeholderText';

export const isSharingDraftBendingTextConfiguration = (
  configuration: SharingDraftConfiguration
): configuration is SharingDraftBendingTextConfiguration => configuration?.type === 'bendingText';

export const isSharingDraftSpecialTextConfiguration = (
  configuration: SharingDraftConfiguration
): configuration is SharingDraftSpecialTextConfiguration => configuration?.type === 'specialText';

export const isSharingDraftConfigurationWithTextOrSpecialText = (
  configuration: SharingDraftConfiguration
): configuration is SharingDraftConfigurationWithText | SharingDraftSpecialTextConfiguration =>
  !isSharingDraftDesignConfiguration(configuration);

export const isSharingDraftConfigurationWithText = (
  configuration: SharingDraftConfiguration
): configuration is SharingDraftConfigurationWithText =>
  isSharingDraftTextConfiguration(configuration) ||
  isSharingDraftPlaceholderTextConfiguration(configuration) ||
  isSharingDraftBendingTextConfiguration(configuration);

export const isSharedConfigurationFilterWithId = (
  filter?: SharingDraftFilterSettings | SharingDraftFilterSettingsById
): filter is SharingDraftFilterSettingsById => Boolean(filter && 'id' in filter);
